export default {"src":"/_next/static/media/italy-flag.2d721139.svg","height":1000,"width":1500,"blurWidth":0,"blurHeight":0};